import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MaterialPricesPage } from '@/features/market/material-prices-page';

const searchSchema = z.object({
  category: z.string().optional().catch(undefined),
  region: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/marketplace/prices/')({
  validateSearch: searchSchema,
  component: PricesRoute,
});

function PricesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MaterialPricesPage
      category={search.category ?? ''}
      region={search.region ?? ''}
      onChange={(next) =>
        void navigate({
          search: { category: next.category || undefined, region: next.region || undefined },
          replace: true,
        })
      }
    />
  );
}
